import holidays from './holidaysContainer';

export default holidays;
